<form [formGroup]="form" class="align-form">
    <div class="field">
        <mat-form-field class="field">
            <mat-label>{{fieldDetails?.name}}</mat-label>
            <mat-select [disableOptionCentering]="true" formControlName="{{fieldDetails?.id}}"
                panelClass="rightFilterSelectPanel">
                <mat-option class="text-capitalize" *ngFor="let option of fieldDetails?.fieldValues"
                    [value]="option._id" selected>
                    {{option.name | titlecase}}
                </mat-option>
            </mat-select>
            <ng-container *ngIf="userSubmit && formValues[fieldDetails?.id].errors">
                <mat-error *ngIf="formValues[fieldDetails?.id].errors?.['required']">
                    <em class="fas fa-exclamation-circle mr-2"></em>{{fieldDetails?.name}} is required
                </mat-error>
            </ng-container>
        </mat-form-field>
    </div>
</form>